import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './SuccessPage.css';
import logo from '../assets/logo.png';

function SuccessPage() {
  const navigate = useNavigate();

  // --- ESTADOS PARA O MODAL DO VGM ---
  const [showVGMModal, setShowVGMModal] = useState(false);
  const [vgmMethod, setVgmMethod] = useState('1'); 
  const [vgmList, setVgmList] = useState([{ booking: '', container: '', weight: '' }]);
  const [isGenerating, setIsGenerating] = useState(false);

  // --- FUNÇÕES DA LISTA DE CONTAINERS ---
  const addVgmRow = () => {
    setVgmList([...vgmList, { booking: '', container: '', weight: '' }]);
  };

  const removeVgmRow = (index) => {
    const newList = vgmList.filter((_, i) => i !== index);
    setVgmList(newList);
  };

  const handleVgmChange = (index, field, value) => {
    const newList = [...vgmList];
    newList[index][field] = value;
    setVgmList(newList);
  };

  // --- FUNÇÃO DE GERAR O ARQUIVO (CHAMA O BACKEND) ---
  const handleGenerateVGM = async () => {
    setIsGenerating(true);
    const token = localStorage.getItem('token'); // Pega o token salvo no login

    try {
      // ATENÇÃO: URL alterada para produção (Coolify)
      const response = await fetch('https://api-draft.hevile.com.br/api/generate-vgm', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          method: vgmMethod,
          vgm_list: vgmList
        })
      });

      if (response.ok) {
        // Converte a resposta em arquivo e força o download
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = "VGM_Documento.docx";
        document.body.appendChild(a);
        a.click();
        a.remove();
        
        setShowVGMModal(false); // Fecha o modal
        alert("✅ Documento VGM baixado com sucesso!");
      } else {
        const errData = await response.json();
        alert('Erro ao gerar documento: ' + (errData.msg || 'Erro desconhecido'));
      }
    } catch (error) {
      console.error('Erro:', error);
      alert('Erro de conexão com o servidor.');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <div className="success-container">
      <div className="success-card">
        <img src={logo} alt="Logo Hevile" className="success-logo" />
        
        <h1>Excel Gerado com Sucesso!</h1>
        
        <p>
          O seu arquivo foi baixado automaticamente. <br /><br />
          Agora, por favor, envie-o para: <br />
          <a href="mailto:sea.exp@hevile.com.br" className="email-link">
            sea.exp@hevile.com.br
          </a>
        </p>

        {/* --- ÁREA DOS BOTÕES --- */}
        <div style={{ display: 'flex', gap: '15px', justifyContent: 'center', marginTop: '20px', flexWrap: 'wrap' }}>
          
          <button className="back-btn" onClick={() => navigate('/')}>
            Criar Novo Draft
          </button>

          <button 
            className="back-btn" 
            style={{ backgroundColor: '#28a745' }} // Cor verde para diferenciar
            onClick={() => setShowVGMModal(true)}
          >
            📄 Gerar Documento VGM
          </button>

        </div>
      </div>

      {/* --- MODAL DO VGM (JANELA POP-UP) --- */}
      {showVGMModal && (
        <div style={{
          position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
          backgroundColor: 'rgba(0,0,0,0.6)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000
        }}>
          <div style={{ 
            backgroundColor: 'white', 
            padding: '25px', 
            borderRadius: '10px', 
            width: '90%', 
            maxWidth: '700px', 
            maxHeight: '90vh', 
            overflowY: 'auto',
            boxShadow: '0 5px 15px rgba(0,0,0,0.3)',
            color: '#333'
          }}>
            <h2 style={{ marginTop: 0, borderBottom: '1px solid #eee', paddingBottom: '10px' }}>Gerar Declaração VGM</h2>
            
            {/* 1. SELEÇÃO DO MÉTODO */}
            <div style={{ marginBottom: '20px', backgroundColor: '#f9f9f9', padding: '15px', borderRadius: '5px' }}>
              <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>1. Qual o método utilizado?</p>
              
              <label style={{ display: 'block', marginBottom: '8px', cursor: 'pointer' }}>
                <input 
                  type="radio" 
                  name="method" 
                  value="1" 
                  checked={vgmMethod === '1'} 
                  onChange={(e) => setVgmMethod(e.target.value)} 
                  style={{ marginRight: '8px' }}
                /> 
                <strong>Método 1:</strong> Pesagem do contêiner lacrado (balança certificada).
              </label>

              <label style={{ display: 'block', cursor: 'pointer' }}>
                <input 
                  type="radio" 
                  name="method" 
                  value="2" 
                  checked={vgmMethod === '2'} 
                  onChange={(e) => setVgmMethod(e.target.value)} 
                  style={{ marginRight: '8px' }}
                /> 
                <strong>Método 2:</strong> Soma dos pesos individuais + Tara.
              </label>
            </div>

            {/* 2. LISTA DE CONTAINERS */}
            <div style={{ marginBottom: '20px' }}>
              <p style={{ fontWeight: 'bold', marginBottom: '10px' }}>2. Lista de Containers</p>
              
              {/* Cabeçalho Visual da Tabela */}
              <div style={{ display: 'flex', gap: '10px', fontSize: '14px', fontWeight: 'bold', color: '#666', marginBottom: '5px' }}>
                <div style={{ flex: 1 }}>Booking</div>
                <div style={{ flex: 1 }}>Nº Container</div>
                <div style={{ flex: 1 }}>Peso (ex: 15.200 KGS)</div>
                <div style={{ width: '30px' }}></div>
              </div>

              {vgmList.map((item, index) => (
                <div key={index} style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
                  <input 
                    placeholder="Booking..." 
                    value={item.booking} 
                    onChange={(e) => handleVgmChange(index, 'booking', e.target.value)}
                    style={{ flex: 1, padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <input 
                    placeholder="CNTR..." 
                    value={item.container} 
                    onChange={(e) => handleVgmChange(index, 'container', e.target.value)}
                    style={{ flex: 1, padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  <input 
                    placeholder="Peso Total..." 
                    value={item.weight} 
                    onChange={(e) => handleVgmChange(index, 'weight', e.target.value)}
                    style={{ flex: 1, padding: '8px', borderRadius: '4px', border: '1px solid #ccc' }}
                  />
                  {vgmList.length > 1 && (
                    <button 
                      onClick={() => removeVgmRow(index)}
                      style={{ color: 'red', background: 'none', border: 'none', cursor: 'pointer', fontSize: '18px', fontWeight: 'bold' }}
                      title="Remover"
                    >
                      &times;
                    </button>
                  )}
                </div>
              ))}
              
              <button 
                onClick={addVgmRow} 
                style={{ 
                  marginTop: '5px', 
                  padding: '5px 10px', 
                  backgroundColor: '#e9ecef', 
                  border: '1px solid #ced4da', 
                  borderRadius: '4px', 
                  cursor: 'pointer',
                  fontSize: '14px'
                }}
              >
                + Adicionar Container
              </button>
            </div>

            {/* AÇÕES DO MODAL */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '15px' }}>
              <button 
                onClick={() => setShowVGMModal(false)} 
                style={{ padding: '10px 20px', cursor: 'pointer', border: 'none', backgroundColor: '#6c757d', color: 'white', borderRadius: '5px' }}
              >
                Cancelar
              </button>
              <button 
                onClick={handleGenerateVGM} 
                disabled={isGenerating}
                style={{ 
                  padding: '10px 20px', 
                  cursor: isGenerating ? 'not-allowed' : 'pointer', 
                  border: 'none', 
                  backgroundColor: '#007bff', 
                  color: 'white', 
                  borderRadius: '5px',
                  opacity: isGenerating ? 0.7 : 1
                }}
              >
                {isGenerating ? 'Gerando...' : '⬇ Baixar .DOCX'}
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}

export default SuccessPage;